<script>
export default {
  name: 'has-pagination',
  data () {
    return {
      currentPage: 1,
      paginationMetaData: null
    };
  },
  beforeMount () {
    if (localStorage.getItem('wedliny-crm-pagination')) {
      let paginationData = JSON.parse(localStorage.getItem('wedliny-crm-pagination'));

      if (paginationData.view && paginationData.view === this.$options.name) {
        this.currentPage = paginationData.page;
      } else {
        localStorage.removeItem('wedliny-crm-pagination');
      }
    }
  },
  mounted () {
    this.$bus.$on('pagination-page-changed', this.setPage);
    this.$bus.$on('pagination-reset', this.resetPagination);
  },
  methods: {
    setPage (page) {
      this.currentPage = page;
      localStorage.setItem('wedliny-crm-pagination', JSON.stringify({
        view: this.$options.name,
        page: this.currentPage
      }));
      this.debouncedLoadFilteredData();
    },
    resetPagination () {
      this.currentPage = 1;
      localStorage.setItem('wedliny-crm-pagination', JSON.stringify({
        view: this.$options.name,
        page: 1
      }));
      this.debouncedLoadFilteredData();
    }
  },
  beforeDestroy () {
    this.$bus.$off('pagination-page-changed', this.setPage);
    this.$bus.$off('pagination-reset', this.resetPagination);
  }
};
</script>
